<template>
    <van-popup
        v-model="visibleDialog"
        position="bottom"
        @close='onClose'
    >
        <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月日"
            :maxDate='maxDate'
            @confirm='onConfirm'
            @cancel='onClose'
        />
    </van-popup>
</template>

<script>
export default {
    props: {
        visible2: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2099, 11, 31),
            currentDate: new Date()
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible2
            },
            set () {
                this.$emit('update:visible2')
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible2')
        },
        onConfirm (value) {
            this.$emit('updateTime', this.formatDateTime(value))
            this.onClose()
        },
        formatDateTime (inputTime) {
            var date = new Date(inputTime)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? ('0' + m) : m
            var d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            return y + '-' + m + '-' + d
        }
    }
}
</script>

<style lang='scss' scoped>
/deep/ .van-picker__toolbar{
    height: 80px;
    line-height: 80px;
}
/deep/ .van-picker__title{
    font-size: 32px;
    line-height: normal;
}
/deep/ .van-picker__cancel{
    font-size: 28px;
    color: #ff7a45;
}
/deep/ .van-picker__confirm{
    font-size: 28px;
    color: #ff7a45;
}
/deep/ .van-picker-column{
    font-size: 28px;
}
</style>